<div class="container">
    <div class="rounded">
      <i class="wi wi-horizon-alt icon"></i>
    </div>
    <div class="temp">
      <h1 style="margin-bottom: 0; font-size: x-large; font-weight: bold;">{{solarRad}} W/m<sup>2</sup></h1>
    </div>
  </div>
